var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.list && _vm.list.length > 0)?_c('BowSlider',{class:_vm.list.length <= 3
            ? 'lg:px-side-spacer xl:px-side-spacer-desktop'
            : '',attrs:{"breakpoints":{
        768: {
            slidesPerView: 2.15,
        },
        1024: {
            centeredSlides: _vm.list.length <= 3 ? false : true,
            slidesPerView: 2.75,
            spaceBetween: 64,
        },
        1280: {
            centeredSlides: _vm.list.length <= 3 ? false : true,
            slidesPerView: _vm.list.length <= 3 ? 3 : 3.5,
            spaceBetween: 96,
        },
    },"centeredSlides":true,"loop":_vm.list.length <= 3 ? false : true,"navigation":false,"pagination":false,"slidesPerView":1.5,"spaceBetween":32}},_vm._l((_vm.list),function(item,idx){return _c('BowSlide',{key:idx},[_c('BowReview',{attrs:{"author":item.author,"link":item.link,"text":item.text}})],1)}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }